"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue, PropSync } from "vue-property-decorator";
import UiDialog from "../../../components/dialog/UiDialog.vue";
import UiForm, { UiFormController } from "@/components/form/UiForm.vue";
import { UiFormAnnotations } from "@/components/form/annotations";
import UiSubmit from "@/components/form/UiSubmit.vue";
import API from "@ym-framework/api-utils";
import { DeviceFormatter } from "@/service/DeviceInfo/deviceFormatter";
import i18n from "@/lang";
import { AccountAuth } from "@/framework/accountauth";
import { LoginService } from "@/service/login";
import { WEB_HTML } from "@/configuration/websocketskey";
let loginService = new LoginService();
class FormController extends UiFormController {
  constructor() {
    super(...arguments);
    this.form_code = "";
    this.form_remember = false;
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "authpinlogin.verification_code_cannot_be_empty"
      ),
      trigger: "blur"
    }
  ])
], FormController.prototype, "form_code", 2);
let AuthPinLogin = class extends Vue {
  constructor() {
    super(...arguments);
    this.Pin_data = null;
    this.span_text = this.$t("authpinlogin.failure_after_minutes");
    this.submit = false;
    this.device_item = null;
    this.loginType = "form";
    this.formcontroller = new FormController();
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.checkVisitorId();
    });
  }
  checkVisitorId() {
    return __async(this, null, function* () {
      try {
        let result = yield API.get(`api://base.local/visitor_id`);
        if (result.data.visitorId !== null) {
          if (this.$matomo) {
            this.$matomo.setVisitorId(result.data.visitorId);
          }
        }
      } catch (error) {
      }
    });
  }
  open(data, type) {
    return __async(this, null, function* () {
      this.submit = false;
      this.Pin_data = data;
      this.loginType = type;
      this._pin_dialog.show();
      yield this.getDevice();
    });
  }
  getDevice() {
    return __async(this, null, function* () {
      let device = yield DeviceFormatter.getInfo();
      console.log(device);
      this.device_item = device;
    });
  }
  sendLog(session) {
    return __async(this, null, function* () {
      try {
        let device = yield DeviceFormatter.getInfo();
        let version = yield API.get(`api://base.local/update/version`);
        let _version = version.data.version;
        yield API.post(`api://base.auth/api/v3/client/logs`, {
          logs: [
            {
              name: "client.login",
              message: "login.success",
              datas: {
                time: {
                  time: new Date().getTime(),
                  date: new Date()
                },
                session,
                version: _version,
                patch: _version,
                computer: {
                  graphics: device.device_info.detail.graphics,
                  os_arch: device.device_info.os_arch,
                  cpu: device.device_info.detail.cpu,
                  os: device.device_info.detail.osInfo,
                  memory: device.device_info.detail.mem,
                  network: device.device_info.detail.networkInterfaces,
                  time: {
                    date: new Date()
                  }
                }
              }
            }
          ]
        });
      } catch (error) {
        console.dir(error);
      }
    });
  }
  submitPin() {
    return __async(this, null, function* () {
      var _a, _b, _c, _d, _e, _f;
      try {
        let _visitor_id = "";
        if (this.$matomo) {
          _visitor_id = this.$matomo.getVisitorId();
        }
        this.submit = true;
        let device = yield DeviceFormatter.getInfo();
        if (this.loginType === "form" || this.loginType === "wechat") {
          let version = yield API.get(`api://base.local/update/version`);
          let response = yield API.post(`api://base.login/v1/auth-pin`, {
            model: "pin.verify",
            verifyCode: this.formcontroller.form_code,
            noNeedVerify: this.formcontroller.form_remember,
            device_info: device.device_info,
            device_mini: device.device_mini,
            device_name: device.device_name,
            allowLogin: false,
            phonePrefix: this._phone_authidprefix
          }, {
            headers: {
              "x-auth-token": this.Pin_data.token,
              "Accept-Language": (_a = localStorage.getItem("lang")) != null ? _a : "zh-CN",
              "os": version.data.os.name,
              "arch": version.data.os.arch
            }
          });
          if (response.data.model === "account.session") {
            try {
              const serviceCodeResponse = yield API.get(`api://base.local/storages/session/deviceToken`);
              const serviceToken = serviceCodeResponse.data.value.deviceToken;
              const device_bind_response = yield API.get(`api://base.auth.message/v1/check/user-devices`, {
                params: {
                  "deviceId": serviceToken
                },
                headers: {
                  "Authorization": response.data.token,
                  "Accept-Language": (_b = localStorage.getItem("lang")) != null ? _b : "zh-CN",
                  "os": version.data.os.name,
                  "arch": version.data.os.arch
                }
              });
              if (device_bind_response.data.bindDevice === true) {
                yield this.$confirm(
                  `${this.$t("phonelogin.device_online_tip_content")}<br/>${this.$t("phonelogin.device_online_tip_sub_account")}<a
                    href="https://www.kuajingvs.com/help2/7048"
                    target="_blank"
                    style="text-decoration: none; color: #1DCF6A"
                  >${this.$t("phonelogin.device_online_tip_sub_account_link")}</a>`,
                  this.$t("vdbindshop.binding_shop_confirm_title"),
                  {
                    roundButton: true,
                    dangerouslyUseHTMLString: true,
                    cancelButtonText: `${this.$t("vdbindshop.binding_tip_cancel")}`,
                    confirmButtonText: `${this.$t("vdbindshop.binding_tip_confirm")}`,
                    closeOnClickModal: false
                  }
                );
              }
            } catch (error) {
              console.log(error);
              if (error === "cancel") {
                return;
              }
            }
            const token_response = yield API.post(`api://base.login/v1/auth-temporary-token`, {}, {
              headers: {
                "x-auth-token": response.data.token,
                "Accept-Language": (_c = localStorage.getItem("lang")) != null ? _c : "zh-CN",
                "os": version.data.os.name,
                "arch": version.data.os.arch
              }
            });
            if (token_response.data.marks !== null && token_response.data.marks.tags.includes("TEAM_JOIN_ALERT")) {
              localStorage.setItem("showJoinTeamMessage", "true");
            }
            loginService.setTokenToLocal(token_response.data.token);
            if (this.Pin_data.remember_password) {
              loginService.savePwdToLocal({
                account: this.Pin_data.account,
                password: this.Pin_data.password,
                remember: this.Pin_data.remember_password,
                sort: +new Date()
              });
            }
            let _session = yield API.get(`api://base/api/v9/account/session`, {
              headers: {
                "X-Auth-Token": token_response.data.token,
                "x-lang": (_d = localStorage.getItem("lang")) != null ? _d : "zh-CN",
                "os": version.data.os.name,
                "arch": version.data.os.arch
              }
            });
            const session = _session.data;
            yield loginService.setSessionToLocal(session);
            yield API.post(`api://base.local/websockets/main`, {
              model: "pageEvent.login.success",
              value: {
                message: "login_success",
                session: _session.data
              }
            });
            yield API.post(`api://base.local/websockets/messageservice`, {
              model: "pageEvent.login.success",
              value: {
                message: "login_success",
                session: _session.data
              }
            });
            if (this.$matomo) {
              this.$matomo.setUserId(_session.data.id);
            }
            yield this.sendLog(_session.data);
            let flag = false;
            let _activity_data = null;
            try {
              let response2 = yield API.get(
                `api://base.auth/api/v8/activity-popups`,
                {
                  params: {
                    scenes: "login"
                  }
                }
              );
              _activity_data = JSON.stringify(response2.data);
              flag = true;
            } catch (error) {
              console.dir(error);
            } finally {
              if (flag) {
                if (this._refer !== "" && this._refer !== null) {
                  window.open(`${this._refer}?token=${token_response.data.token}&name=${_session.data.name}`, "_self");
                  return;
                }
                let _href = `${WEB_HTML}/?activity=${_activity_data}`;
                if (this._jump !== "" && this._jump !== null) {
                  if (this._jump.indexOf("?") !== -1) {
                    _href = `${WEB_HTML}/${this._jump}&activity=${_activity_data}`;
                  } else {
                    _href = `${WEB_HTML}/${this._jump}?activity=${_activity_data}`;
                  }
                  if (this._jump === "rpa") {
                    _href = `https://rpa.kuajingvs.com`;
                  }
                  if (this._jump === "yunhao") {
                    _href = `https://yunhao.kuajingvs.com/`;
                  }
                  if (this._jump === "ai") {
                    _href = `https://app.kuajingvs.com/ai`;
                  }
                }
                window.open(_href, "_self");
              }
              if (!flag) {
                if (this._refer !== "" && this._refer !== null) {
                  window.open(`${this._refer}?token=${token_response.data.token}&name=${_session.data.name}`, "_self");
                  return;
                }
                let _href = `${WEB_HTML}/`;
                if (this._jump !== "" && this._jump !== null) {
                  _href = `${WEB_HTML}/${this._jump}`;
                  if (this._jump === "rpa") {
                    _href = `https://rpa.kuajingvs.com`;
                  }
                  if (this._jump === "yunhao") {
                    _href = `https://yunhao.kuajingvs.com/`;
                  }
                  if (this._jump === "ai") {
                    _href = `https://app.kuajingvs.com/ai`;
                  }
                }
                window.open(_href, "_self");
              }
            }
          }
        }
        if (this.loginType === "team") {
          let response = yield API.post(
            `api://base/api/v7_1/account/auth_by_token/org/${this.Pin_data.org_guid}`,
            {
              device_info: this.device_item.device_info,
              device_mini: this.device_item.device_mini,
              device_name: this.device_item.device_name,
              pin_verify_status: true,
              visitor_id: _visitor_id,
              token: this.Pin_data.token
            }
          );
          yield API.post(
            `api://base.local/auth`,
            {},
            {
              headers: {
                "x-auth-token": response.data.account_session.token,
                "Accept-Language": (_e = localStorage.getItem("lang")) != null ? _e : "zh-CN"
              }
            }
          );
          let _session = yield API.get(
            `api://base.local/accounts/session`
          );
          if (this.$matomo) {
            this.$matomo.setUserId(_session.data.id);
          }
          yield AccountAuth.authAfter(_session.data);
          yield this.sendLog(_session.data);
          yield API.post(`api://base.local/websockets/messageservice`, {
            model: "pageEvent.changeTeam.success",
            value: {
              message: "changeteam.success"
            }
          });
          location.reload();
        }
      } catch (error) {
        this.submit = false;
        console.log(error);
        if (error.hasOwnProperty("response")) {
          this.$message.error((_f = error.response.data.errors) == null ? void 0 : _f.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("pin-dialog")
], AuthPinLogin.prototype, "_pin_dialog", 2);
__decorateClass([
  PropSync("phoneAuthid", {
    default: function() {
      return "";
    }
  })
], AuthPinLogin.prototype, "_phone_authid", 2);
__decorateClass([
  PropSync("phoneAuthidprefix", {
    default: function() {
      return "";
    }
  })
], AuthPinLogin.prototype, "_phone_authidprefix", 2);
__decorateClass([
  PropSync("phonePassword", {
    default: function() {
      return "";
    }
  })
], AuthPinLogin.prototype, "_phone_password", 2);
__decorateClass([
  PropSync("phoneRemember", {
    default: function() {
      return false;
    }
  })
], AuthPinLogin.prototype, "_phone_remember", 2);
__decorateClass([
  PropSync("jump", {
    default: function() {
      return "";
    }
  })
], AuthPinLogin.prototype, "_jump", 2);
__decorateClass([
  PropSync("refer")
], AuthPinLogin.prototype, "_refer", 2);
AuthPinLogin = __decorateClass([
  Component({
    components: { UiSubmit, UiForm, UiDialog }
  })
], AuthPinLogin);
export {
  AuthPinLogin as default
};
